import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { MajorCard } from "../../shared/component/Card/Card";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import ListingComponent from "../../shared/component/ListingComponent/ListingComponent";
import FilterBox from "../../shared/component/FilterBox/FilterBox";
import NoContentComponent from "../../shared/component/NoContentComponent/NoContentComponent";
import { toast } from "react-toastify";
import ViewMoreBox from "../../shared/component/FilterBox/ViewMoreBox";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import { SearchIcon } from "../../shared/component/svg/Icons";
import { formatString } from "../../shared/utils/string";
import useDebounce from "../../shared/hooks/debounce";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import { MajorListCard } from "../../shared/component/ListItem/ListItem";
import DualRangeSlider from "../../shared/component/FilterBox/DualRangeSlider";

const ITEMS_PER_PAGE = 60;

const DEGREE_OPT = [
	{ id: "D1", name: Variable.DIPLOMA_1, abbv: "D-1" },
	{ id: "D2", name: Variable.DIPLOMA_2, abbv: "D-2" },
	{ id: "D3", name: Variable.DIPLOMA_3, abbv: "D-3" },
	{ id: "D4", name: Variable.DIPLOMA_4, abbv: "D-4" },
	{ id: "S1", name: Variable.UNDERGRAD, abbv: "S-1" },
	{ id: "S2", name: Variable.POSTGRAD, abbv: "S-2" },
	{ id: "S3", name: Variable.DOCTORAL, abbv: "S-3" },
	{ id: "Profession", name: Variable.PROFESSION },
	{ id: "Sp-1", name: Variable.SPECIALIST_1, abbv: "Sp-1" },
	{ id: "Sp-2", name: Variable.SPECIALIST_2, abbv: "Sp-2" },
];
// const tuitionFilter = [
// 	{ id: "1,5000000", name: "1 - 5 jt" },
// 	{ id: "5000000,10000000", name: "5 - 10 jt" },
// 	{ id: "10000000,15000000", name: "10 - 15 jt" },
// 	{ id: "15000000,20000000", name: "15 - 20 jt" },
// 	{ id: "20000000,25000000", name: "20 - 25 jt" },
// 	{ id: "25000000,50000000", name: "25 - 50 jt" },
// 	{ id: "50000000,100000000", name: "50 - 100 jt" },
// ];

const predefinedMajors = ['Fakultas Ekonomi','Fakultas Keguruan dan Ilmu Pendidikan', 'Fakultas Matematika dan Ilmu Pengetahuan Alam', ]

const MajorListing = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	const [majors, setMajors] = useState(null);
	const [faculties, setFaculties] = useState(null);
	const [facultiesLoading, setFacultiesLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(null);
	const [viewMore, setViewMore] = useState({});
	const [filters, setFilters] = useState({
		tuition: "allTuition",
		faculties: {
			facultiesAll: false
		}
	});
	const [searchTemp, setSearchTemp] = useState("");
	const debounceSearch = useDebounce(searchTemp, 750);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState({
		has_next: false,
		total_items: 0,
	});
	const [view, setView] = useState("big");
	const [tuitionFeeInput, setTuitionFeeInput] = useState({
		minInput: 0,
		maxInput: 105000000
	})
	const currency = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        currencyDisplay: "code",
        trailingZeroDisplay: "stripIfInteger",
    });

	useEffect(() => {
		getFaculties();
	}, []);

	useEffect(() => {
		if (searchTemp !== filters?.search && (searchTemp.length >= 3 || searchTemp === "")) {
			setFilters((p) => ({ ...p, search: debounceSearch }));
		}
	}, [debounceSearch]); // eslint-disable-line

	useEffect(() => {
		setPage(1);
		getMajors(1);
	}, [filters]); // eslint-disable-line

	useEffect(() => {
		if (page > 1) getMajors(page);
	}, [page]); // eslint-disable-line

	const getFaculties = async () => {
		setFacultiesLoading(true);
		let res = await makeRequest(generateRequestOptions("facultiesList", { queryParams: { page_size: 1000 } }));
		if (res.code === 200) {
			const facultiesMap = res.data.map((i)=> {
				return {
					...i,
					count_majors: i.count
				}
			})
			const matchingMajors = facultiesMap.filter(item => predefinedMajors.includes(item.faculty_category));
			const otherMajors = facultiesMap.filter(item => !predefinedMajors.includes(item.faculty_category));

			// Sort the matchingMajors based on predefinedMajors order
			const sortedMatchingMajors = matchingMajors.sort((a, b) => {
			const indexA = predefinedMajors.indexOf(a.faculty_category);
			const indexB = predefinedMajors.indexOf(b.faculty_category);
			return indexA - indexB;
			});

			// Combine the sorted matchingMajors and otherMajors arrays
			const combinedArray = sortedMatchingMajors.concat(otherMajors);

			setFaculties(combinedArray.filter((i) => i?.faculty_category && i?.count_majors > 0));
		}
		setFacultiesLoading(false);
	};

	const getMajors = async (page) => {
		if (isLoading) return;
		setIsLoading(true);

		// Store the current value, and add the loading card
		// While the API is calling
		let currMajors = page === 1 ? [] : majors || [];
		setMajors([
			...currMajors,
			...[...Array(ITEMS_PER_PAGE)].map((i) => ({
				isLoading: true,
			})),
		]);

		let tempFaculties = filters?.faculties?.["facultiesAll"] ? {} : filters?.faculties;
		let tempTuition = filters?.tuition === "allTuition" ? undefined : filters?.tuition;

		// Call the API
		let res = await makeRequest(
			generateRequestOptions("majorList", {
				queryParams: {
					page,
					page_size: ITEMS_PER_PAGE,
					search: filters?.search || undefined,
					faculty_category: Object.keys(tempFaculties || {})?.filter((i) => filters?.faculties?.[i]),
					degrees: Object.keys(filters?.degree || {})?.filter((i) => filters?.degree?.[i]),
					tuition_fee_per_semester: tempTuition,
				},
				queryOptions: { arrayFormat: "repeat" },
			})
		);
		if (res.code === 200) {
			setMajors([...currMajors, ...res.data]);
			setTotal({ has_next: res.next, total_items: res.total_items });
		} else {
			setMajors(currMajors);
			setTotal((p) => ({ ...p, has_next: false }));
			toast.error(res.message || Variable.SOMETHING_WENT_WRONG_TRY_AGAIN[ENV_NAME]);
		}

		setIsLoading(false);
	};

	const onChangeField = (e, parent, radio = false) => {
		if (radio) {
			setFilters((p) => ({ ...p, [parent]: e.target.id }));
		} else {
			setFilters((p) => ({
				...p,
				[parent]: {
					...p?.[parent],
					...(p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
					[e.target.name]: e.target.checked,
				},
			}));
		}
	};

	const openViewMore = (name, open = true) => {
		setViewMore((p) => ({ ...p, [name]: open }));
	};

	const getSelectedFilterCount = (type) => {
		if (filters.faculties.facultiesAll) {
			return faculties.length;
		}

        return Object.values(type).slice(1, type.length).filter(e => e === true).length;
    }

	const tuitionDebounce = useDebounce(tuitionFeeInput, 500)
	useEffect(()=> {
		setFilters((prev)=>{
			return {
				...prev,
				tuition: tuitionDebounce.maxInput > 100000000 ? `${tuitionDebounce.minInput},1000000000000`: `${tuitionDebounce.minInput},${tuitionDebounce.maxInput}`
			}
		})	
	}, [tuitionDebounce])

	return (
		<ListingComponent
			className="major-listing"
			hasView={true}
			view={view}
			setView={setView}
			filters={
				<>
					<FilterBox>
						<div className="form-group search-bar mb-0">
							<SearchIcon className="searchIcon" />
							<input
								type="text"
								name="searchText"
								value={searchTemp || ""}
								onChange={(e) => setSearchTemp(e.target.value)}
								placeholder={formatString(
									Variable.SRC_BY_PLACEHOLDER[ENV_NAME],
									Variable.MAJOR[ENV_NAME]
								)}
							/>
						</div>
					</FilterBox>
					<FilterBox header={Variable.FACULTY_NAME[ENV_NAME]} collapsible={1} eventkey="0" opendefault={1}>
						{facultiesLoading ? (
							<LoadingComponent notFullScreen loadingLabel=" " />
						) : (
							<>
								<div className="form-group form-check">
									<div className="custom-control custom-checkbox">
										<input
											type="checkbox"
											className="form-check-input"
											id="facultiesAll"
											name="facultiesAll"
											checked={filters?.faculties?.facultiesAll || false}
											onChange={(e) => onChangeField(e, "faculties")}
											disabled={isLoading}
										/>
										<label className="form-check-label" htmlFor="facultiesAll">
											{Variable.ALL_FACULTY[ENV_NAME]}
											<span className="filter-count">{`(${faculties?.reduce(
												(acc, curr) => acc + curr?.count_majors,
												0
											)})`}</span>
										</label>
									</div>
								</div>
								{(faculties || [])?.slice(0, 3)?.map((i, idx) => (
									<div className="form-group form-check" key={"faculties-" + idx}>
										<div className="custom-control custom-checkbox">
											<input
												type="checkbox"
												className="form-check-input"
												id={i?.faculty_category}
												name={i?.faculty_category}
												checked={
													filters?.faculties?.[i?.faculty_category] ||
													filters?.faculties?.facultiesAll ||
													false
												}
												onChange={(e) => onChangeField(e, "faculties")}
												disabled={isLoading}
											/>
											<label className="form-check-label" htmlFor={i?.faculty_category}>
												{i?.faculty_category}
												<span className="filter-count">{`(${i?.count_majors})`}</span>
											</label>
										</div>
									</div>
								))}
								{faculties?.length > 5 && (
									<button className="btn btn-view-more" onClick={() => openViewMore("faculty", true)}>
										{Variable.VIEW_MORE[ENV_NAME]} {!!getSelectedFilterCount(filters.faculties) && `(${getSelectedFilterCount(filters.faculties)} ${Variable.APPLIED[ENV_NAME]})`} 
									</button>
								)}
							</>
						)}
					</FilterBox>
					<ViewMoreBox
						open={viewMore?.faculty || false}
						onHide={() => openViewMore("faculty", false)}
						data={[
							{
								id: "facultiesAll",
								name: Variable.ALL_FACULTY[ENV_NAME],
								count_majors: faculties?.reduce((acc, curr) => acc + curr?.count_majors, 0),
							},
							...(faculties?.map((i) => ({
								...i,
								id: i?.faculty_category,
								name: i?.faculty_category,
								count_majors: i?.count_majors,
							})) || []),
						]}
						parent="faculties"
						filters={filters}
						onSave={(data) => setFilters((p) => ({ ...p, ...data, faculties: data?.faculties }))}
						searchPlaceholder={Variable.SRC_FACULTY[ENV_NAME]}
						withCount={1}
					/>
					<FilterBox header={Variable.TUITION_FEE_SMT[ENV_NAME]} collapsible={1} eventkey="1" opendefault={1}>
						<div className="salary_inputs">
							<input 
								className="min_input input"
								placeholder="0"
								value={currency.format(tuitionFeeInput.minInput)}	
							/>
							to
							<input 
								className="min_input input"
								placeholder="40.000.000"
								value={tuitionFeeInput.maxInput > 100000000 ? `IDR 100.000.000 +` : currency.format(tuitionFeeInput.maxInput)}	
							/>
						</div>
						<DualRangeSlider min={0} max={105_000_000} onUpdate={({min, max})=> {
							setTuitionFeeInput({minInput:min, maxInput:max});						
						}} ENV_NAME={ENV_NAME}/>
					</FilterBox>
					<FilterBox header={Variable.DEGREE[ENV_NAME]} collapsible={1} eventkey="1" opendefault={1}>
						{DEGREE_OPT?.map((i) => (
							<div key={i?.id} className="form-group form-check">
								<div className="custom-control custom-checkbox">
									<input
										type="checkbox"
										className="form-check-input"
										id={`${i?.id}`}
										name={`${i?.id}`}
										checked={filters?.degree?.[`${i?.id}`] || false}
										onChange={(e) => onChangeField(e, "degree")}
										disabled={isLoading}
									/>
									<label className="form-check-label" htmlFor={`${i?.id}`}>
										{i?.name?.[ENV_NAME]}
										{i?.abbv && <span className="filter-count">{`(${i?.abbv})`}</span>}
									</label>
								</div>
							</div>
						))}
					</FilterBox>
				</>
			}
			contents={
				!isLoading && majors?.length === 0 ? (
					<NoContentComponent className="my-xl" description=" " />
				) : (
					(majors || [])?.map((i, idx) => (
						<Link
							key={i?.id || idx}
							to={i?.id ? RoutePath.MAJOR_DETAIL + "/" + i?.id : ""}
							className="text-decoration-none text-label-dark-gray-2"
						>
							{view !== "list" ? (
								<MajorCard
									key={i?.id || idx}
									isLoading={i?.isLoading}
									data={i?.isLoading ? undefined : i}
									onClickFavorite={() => {
										if (i?.isLoading || fetchingAddRemoveFavorites) return;
										if (isAuthenticated) {
											props.addRemoveFavorite(
												i?.is_favourite ? "remove" : "add",
												"major",
												i?.is_favourite ? i?.fav_obj_id : i?.id,
												(res) => {
													setMajors((prev) =>
														prev.map((p) => {
															if (p?.id !== i?.id) return p;
															return {
																...p,
																is_favourite: !i?.is_favourite,
																fav_obj_id: i?.is_favourite ? null : res?.data?.id,
															};
														})
													);
												}
											);
										} else {
											props.openLoginModal();
										}
									}}
									onClick={() => {}}
									ENV_NAME={ENV_NAME}
									smallcard={view === "small"}
								/>
							) : (
								<MajorListCard
									key={i?.id || idx}
									isLoading={i?.isLoading}
									data={i?.isLoading ? undefined : i}
									onClickFavorite={() => {
										if (i?.isLoading || fetchingAddRemoveFavorites) return;
										if (isAuthenticated) {
											props.addRemoveFavorite(
												i?.is_favourite ? "remove" : "add",
												"major",
												i?.is_favourite ? i?.fav_obj_id : i?.id,
												(res) => {
													setMajors((prev) =>
														prev.map((p) => {
															if (p?.id !== i?.id) return p;
															return {
																...p,
																is_favourite: !i?.is_favourite,
																fav_obj_id: i?.is_favourite ? null : res?.data?.id,
															};
														})
													);
												}
											);
										} else {
											props.openLoginModal();
										}
									}}
									onClick={() => {}}
									ENV_NAME={ENV_NAME}
									smallcard={view === "small"}
								/>
							)}
						</Link>
					))
				)
			}
			contentsClassName={!isLoading && majors?.length === 0 ? "no-grid" : undefined}
			showingLabel={`${total?.total_items || 0} ${Variable.MAJORS[ENV_NAME]}`}
			showMoreOnClick={() => !isLoading && setPage((p) => p + 1)}
			hasMore={!isLoading ? total.has_next : false}

		/>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(MajorListing));
